import { render } from "./CharlaCookieNotification.vue?vue&type=template&id=b2ef0a70"
import script from "./CharlaCookieNotification.vue?vue&type=script&lang=js"
export * from "./CharlaCookieNotification.vue?vue&type=script&lang=js"

import "./CharlaCookieNotification.vue?vue&type=style&index=0&id=b2ef0a70&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__